import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../../../shared/interfaces/error-info.interface';
import { ResponseModel } from '../../../shared/interfaces/response-model.interface';
import api from '../../../shared/services/utils/api/api.service';
import errorHelper from '../../../shared/services/utils/api/error-helper.service';
import {
  OccupancyDatasetModel,
  OccupancyDatasetQueryModel
} from '../../../shared/models/occupancy-dashboard.model';
import { DashboardPortfolio } from '../../../shared/ui-models/occupancy-dashboard.ui-model';
import OccupancyDashboardMapper from '../../../shared/mappers/occupancy-dashboard.mapper';

const MODULE_NAME = 'OCCUPANCY_RATE_MODULE';

export function getOccupancyPortfolio(
  query: OccupancyDatasetQueryModel
): Promise<DashboardPortfolio | ErrorInfo> {
  return api
    .getOccupancyDashboardDataset(query)
    .then((response: ApiResponse<ResponseModel<OccupancyDatasetModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return OccupancyDashboardMapper.mapToUI(data.data);
        }
        return errorHelper(
          0,
          '',
          MODULE_NAME,
          (api.getOccupancyDashboardDataset as any).displayName
        );
      }
      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getOccupancyDashboardDataset as any).displayName
      );
    });
}
